import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { usePathSet } from '@/hooks/usePathSet';
import { SignedInPageLayout } from '@/layout/signed-in-page';
import { useMenuItems } from '@/pages/shared/hooks/useMenuItems';

import { WorkstreamForm } from './components/WorkstreamForm';

export const AddWorkstreamPage = () => {
  const { t } = useTranslation();
  const menuItems = useMenuItems();
  const paths = usePathSet();

  return (
    <SignedInPageLayout
      items={menuItems}
      navBarProps={{
        title: t('global.workstream.actions.add'),
        backPath: paths.workstreams,
        showSearchBar: false,
      }}
    >
      <Stack spacing={10}>
        <WorkstreamForm />
      </Stack>
    </SignedInPageLayout>
  );
};
